module.exports = __webpack_public_path__ + "5ba9a2a229b94c98c6ac3eb9c75daead.svg";